import { render, staticRenderFns } from "./updateQtyRecord.vue?vue&type=template&id=05684848&scoped=true"
import script from "./updateQtyRecord.vue?vue&type=script&lang=js"
export * from "./updateQtyRecord.vue?vue&type=script&lang=js"
import style0 from "./updateQtyRecord.vue?vue&type=style&index=0&id=05684848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05684848",
  null
  
)

export default component.exports